module.exports = __webpack_public_path__ + "static/media/play.2dcc42a6.svg";